import { useMutation } from '@apollo/client';
import React, { useContext } from 'react';
import { ActionButton } from '../../components/connectedForm/Button/Button';
import { useBackgroundProcess } from '../../utils/BackgroundJobs';
import PayByLinkSync from '../../graphql/mutations/salesLedger/PayByLinkSync.graphql';
import { useComponentQueryErrorHandling } from '../../utils/parseErrorResponse';
import getClientMutationId from '../../utils/getClientMutationId';
import WorkspaceContext from '../../components/Context/WorkspaceContext';

const PayByLinkSyncAction = () => {
  const workspace = useContext(WorkspaceContext);
  const handleQueryError = useComponentQueryErrorHandling();

  const [sync] = useMutation(PayByLinkSync, {
    onError: handleQueryError,
  });

  // @ts-ignore - still JS
  const runBackgroundProcess = useBackgroundProcess({
    title: 'Syncing',
    onComplete: () => workspace.reloadData?.(),
  });

  const onClick = () => {
    sync({
      variables: {
        input: {
          clientMutationId: getClientMutationId(),
        },
      },
    }).then((response) => {
      const key = Object.keys(response.data)[0];
      runBackgroundProcess(response.data[key].result);
    });
  };

  // @ts-ignore - still JS
  return <ActionButton label="Sync" onClick={onClick} />;
};

export const actions = [
  {
    actionReference: 'PAY_BY_LINK_SYNC',
    element: <PayByLinkSyncAction />,
  },
];
